module.exports = __webpack_public_path__ + "img/other_gift.803fe8ed.png";